import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { SlangNode } from './SlangNode.js';
import { AbicoderVersion } from './AbicoderVersion.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class AbicoderPragma extends SlangNode {
  readonly kind = NonterminalKind.AbicoderPragma;

  version: AbicoderVersion;

  constructor(ast: ast.AbicoderPragma, collected: CollectedMetadata) {
    super(ast, collected);

    this.version = new AbicoderVersion(ast.version, collected);

    this.updateMetadata(this.version);
  }

  print(print: PrintFunction): Doc {
    return ['abicoder ', print('version')];
  }
}
